import { hasCookie, setCookie } from 'cookies-next';
const DEVICE_ID_COOKIE_NAME = 'CBS_DEVICEID';
import { DEFAULT_MAX_AGE } from '@tn/foundation/utils/constants/common';

export default function setDeviceIdCookie() {
    if (hasCookie(DEVICE_ID_COOKIE_NAME)) {
        return;
    }

    const delay = 1000;
    const maxAttempts = 30;
    let attempts = 0;

    const timerId = window.setInterval(() => {
        attempts += 1;

        // alloy is an adobe function injected into the page through
        // tealium by MOPS team.
        // See CBSCOMSUB-9248 for more details
        const maybeAlloy = (
            window as typeof window & {
                alloy?: (command: string) => Promise<{ identity?: { ECID?: string } }>;
            }
        ).alloy;

        if (typeof maybeAlloy === 'function') {
            maybeAlloy('getIdentity')
                .then((result) => {
                    const ecid = result?.identity?.ECID;
                    if (ecid) {
                        // Re-check cookie existence to avoid overwriting a value set by another script
                        if (!hasCookie(DEVICE_ID_COOKIE_NAME)) {
                            setCookie(DEVICE_ID_COOKIE_NAME, ecid, {
                                // Set cookie to expire in 1 year
                                maxAge: DEFAULT_MAX_AGE,
                            });
                        }
                        window.clearInterval(timerId);
                    }
                })
                // Errors are intentionally suppressed; polling continues until maxAttempts
                .catch(() => {});
        }

        if (attempts >= maxAttempts) {
            window.clearInterval(timerId);
        }
    }, delay);

    return () => {
        window.clearInterval(timerId);
    };
}
